"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GroupedTableCell = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TableProps = require("../TableProps");
var _RowGroupToggle = require("../TableBody/RowGroupToggle");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const GroupedTableCell = _ref => {
  let {
    cell,
    row,
    showSubRowCount = true
  } = _ref;
  // If it's a grouped cell, add an expander and optional row count
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "groupedCellContents"
  }, /*#__PURE__*/_react.default.createElement(_RowGroupToggle.RowGroupToggle, {
    row: row
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "cellContents"
  }, cell.render('Cell', {
    editable: false
  })), showSubRowCount && /*#__PURE__*/_react.default.createElement("span", {
    className: "tableSubRowCount"
  }, row.subRows.length));
};
exports.GroupedTableCell = GroupedTableCell;
GroupedTableCell.propTypes = {
  cell: _TableProps.TableCellProps,
  row: _TableProps.TableRowProps,
  showSubRowCount: _propTypes.default.bool
};